var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-list",
    [
      _c(
        "q-collapsible",
        {
          staticClass: "filter",
          attrs: {
            icon: "fas fa-filter",
            label: _vm.$t("filter"),
            opened: !_vm.$q.platform.is.mobile ? true : false
          }
        },
        [
          _c(
            "q-list",
            { attrs: { "no-border": "" } },
            [
              _c(
                "q-item",
                [
                  _c(
                    "q-item-main",
                    [
                      _c("q-search", {
                        attrs: {
                          placeholder: _vm.$t("search"),
                          icon: "fas fa-search",
                          debounce: 500
                        },
                        model: {
                          value: _vm.search,
                          callback: function($$v) {
                            _vm.search = $$v
                          },
                          expression: "search"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "q-item",
                [
                  _c(
                    "q-item-main",
                    [
                      _c("p", { staticClass: "caption" }, [
                        _vm._v(_vm._s(_vm.$t("transmissions")))
                      ]),
                      _c("q-btn-toggle", {
                        staticClass: "full-width q-mb-sm progress",
                        attrs: {
                          "toggle-color": "primary",
                          options: [
                            {
                              label: _vm.$t("all_f"),
                              value: "all",
                              icon: "fas fa-list"
                            }
                          ]
                        },
                        model: {
                          value: _vm.progress,
                          callback: function($$v) {
                            _vm.progress = $$v
                          },
                          expression: "progress"
                        }
                      }),
                      _c("q-btn-toggle", {
                        staticClass: "full-width q-mb-sm progress",
                        attrs: {
                          "toggle-color": "primary",
                          options: [
                            {
                              label: _vm.$t("next_f"),
                              value: "to-do",
                              icon: "far fa-calendar-times"
                            }
                          ]
                        },
                        model: {
                          value: _vm.progress,
                          callback: function($$v) {
                            _vm.progress = $$v
                          },
                          expression: "progress"
                        }
                      }),
                      _c("q-btn-toggle", {
                        staticClass: "full-width progress",
                        attrs: {
                          "toggle-color": "primary",
                          options: [
                            {
                              label: _vm.$t("finished_f"),
                              value: "finished",
                              icon: "far fa-check-circle"
                            }
                          ]
                        },
                        model: {
                          value: _vm.progress,
                          callback: function($$v) {
                            _vm.progress = $$v
                          },
                          expression: "progress"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "q-item",
                [
                  _c(
                    "q-item-main",
                    [
                      _c("p", { staticClass: "caption" }, [
                        _vm._v(_vm._s(_vm.$t("knowledge_areas")))
                      ]),
                      _vm._l(_vm.all_areas, function(area, index) {
                        return _c(
                          "q-item",
                          { key: index, attrs: { tag: "label", link: "" } },
                          [
                            _c(
                              "q-item-side",
                              [
                                _c("q-checkbox", {
                                  attrs: { val: area.value },
                                  model: {
                                    value: _vm.areas,
                                    callback: function($$v) {
                                      _vm.areas = $$v
                                    },
                                    expression: "areas"
                                  }
                                })
                              ],
                              1
                            ),
                            _c(
                              "q-item-main",
                              [
                                _c(
                                  "q-item-tile",
                                  {
                                    staticClass: "text-weight-light",
                                    attrs: { label: "" }
                                  },
                                  [_vm._v(_vm._s(area.label))]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      })
                    ],
                    2
                  )
                ],
                1
              ),
              _c(
                "q-item",
                [
                  _c("q-item-main", [
                    _c("p", { staticClass: "text-center" }, [
                      _c(
                        "a",
                        {
                          staticClass: "text-faded",
                          attrs: { href: "#" },
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              return _vm.clearFilters()
                            }
                          }
                        },
                        [
                          _c("q-icon", { attrs: { name: "far fa-trash-alt" } }),
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("clear_filters")) +
                              "\n                        "
                          )
                        ],
                        1
                      )
                    ])
                  ])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }